import P from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import styles from './grid.module.less';

import UniversalText from '../universal-text/universal-text';
import UniversalImage from '../universal-image/universal-image';
import UniversalButton from '../universal-button/universal-button';
import YouTubePlayer from '../../lib/youtube-player/youtube-player';
import Mp4VideoPlayer from '../../lib/mp4-video-player/mp4-video-player';
import SpotifyPlayer from '../../lib/spotify-player';
import SoundCloudPlayer from '../../lib/soundcloud-player';
import UniversalAccordion from '../universal-accordion/universal-accordion';
import BainReferralBannerSC from '../bain-referral-banner-sc/bain-referral-banner-sc';
import AdvertiserDisclosureWrapper from '../advertiser-disclosure/advertiser-disclosure';
import LottieAnimation from '../lottie-animation/lottie-animation';
import { componentTypes } from './lib/component-types';
import CurrentDate from '../current-date/current-date';
import ThirdPartyEmbedV2 from '../third-party-embed-v2/third-party-embed-v2';

const ItemComponent = ({
  type,
  text,
  image,
  button,
  youtube,
  mp4Video,
  spotify,
  soundcloud,
  bainReferralBanner,
  advertiserDisclosure,
  accordion,
  lottie,
  size,
  currentDate,
  thirdPartyEmbed,
}) => {
  switch (type) {
    case componentTypes.TEXT: {
      return <UniversalText {...text} outputSample viewPortSize={size} />;
    }
    case componentTypes.IMAGE: {
      return <UniversalImage {...image} outputSample />;
    }
    case componentTypes.YOUTUBE: {
      return <YouTubePlayer {...youtube} includeContainer />;
    }
    case componentTypes.MP4VIDEO: {
      return <Mp4VideoPlayer {...mp4Video} outputSample includeContainer />;
    }
    case componentTypes.SPOTIFY: {
      return <SpotifyPlayer {...spotify} outputSample includeContainer />;
    }
    case componentTypes.SOUNDCLOUD: {
      return <SoundCloudPlayer {...soundcloud} outputSample includeContainer />;
    }
    case componentTypes.BUTTON: {
      return <UniversalButton {...button} outputSample includeContainer />;
    }
    case componentTypes.BAINREFERRALBANNER: {
      return <BainReferralBannerSC {...bainReferralBanner} />;
    }
    case componentTypes.ADVERTISERDISCLOSURE: {
      return <AdvertiserDisclosureWrapper {...advertiserDisclosure} />;
    }
    case componentTypes.ACCORDION: {
      return <UniversalAccordion {...accordion} />;
    }
    case componentTypes.LOTTIE: {
      return <LottieAnimation {...lottie} />;
    }
    case componentTypes.CURRENTDATE: {
      return <CurrentDate {...currentDate} />;
    }
    case componentTypes.THIRDPARTYEMBED: {
      return <ThirdPartyEmbedV2 {...thirdPartyEmbed} />;
    }

    default:
      return null;
  }
};

const ConnectedItemComponent = connect(
  createStructuredSelector({
    size: (state) => state?.mediaQuery,
  })
)(ItemComponent);

const ItemComponents = ({ components, outputDashedBorder }) => {
  const outputEmptyGridItemStyle = !components?.some((item) => 'type' in item);

  return (
    <div
      className={classNames([
        { [styles.itemComponentBorder]: outputDashedBorder },
        { [styles.emptyGridItemStyle]: outputEmptyGridItemStyle },
      ])}
    >
      {components?.map((component) => (
        <ConnectedItemComponent key={component.$unique_key} {...component} />
      ))}
    </div>
  );
};

ItemComponents.propTypes = {
  components: P.array,
  outputDashedBorder: P.bool,
};

ItemComponents.defaultProps = {
  components: [],
  outputDashedBorder: false,
};

ItemComponent.propTypes = {
  type: P.string,
  text: UniversalText.propTypes,
  image: UniversalImage.propTypes,
  button: UniversalButton.propTypes,
  youtube: YouTubePlayer.propTypes,
  mp4Video: Mp4VideoPlayer.propTypes,
  spotify: SpotifyPlayer.propTypes,
  soundcloud: SoundCloudPlayer.propTypes,
  bainReferralBanner: BainReferralBannerSC.propTypes,
  advertiserDisclosure: AdvertiserDisclosureWrapper.propTypes,
  accordion: UniversalAccordion.propTypes,
  lottie: LottieAnimation.propTypes,
  currentDate: CurrentDate.propTypes,
  thirdPartyEmbed: ThirdPartyEmbedV2.propTypes,
  size: P.string,
};

ItemComponent.defaultProps = {
  type: 'none',
  text: {},
  image: {},
  button: {},
  youtube: {},
  mp4Video: {},
  spotify: {},
  soundcloud: {},
  bainReferralBanner: {},
  advertiserDisclosure: {},
  accordion: {},
  currentDate: {},
  lottie: {},
};

export default ItemComponents;
